
export default {
    getChats: (state, getters, rootState) => {
        return state.chats.filter((ct) => ct.content.toLowerCase().includes(state.chatSearchQuery.toLowerCase()))
    },
}
